export default __webpack_public_path__ + "static/GraphikWeb-Semibold-af7e56ed22fcd8046dfc52a5cfacb846.woff";